<skeleton-story-item
  [class]="cssClassItem"
  *ngFor="let item of listItem"
  [isListView]="isListView"
  [showDate]="showDate"
  [showTags]="showTags"
  [showAuthor]="showAuthor"
  [showMedia]="showMedia"
  [mediaType]="mediaType"
  [showHeader]="showHeader"
  [showDescription]="showDescription"
  [showContributors]="showContributors"
  [imageHeight]="imageHeight"
  [titleLines]="titleLines"
  [descriptionLines]="descriptionLines"
  [tagCount]="tagCount"
  [contributorCount]="contributorCount">
</skeleton-story-item>
